import { Button } from '@pms-digital/design-system';

interface AucunResultatProps {
  /** Clears the search and the filter. */
  onToutAfficher: () => void;
}

/** The search or the filter keep nothing. */
export function AucunResultat({ onToutAfficher }: AucunResultatProps) {
  return (
    <div className="flex flex-col items-start gap-3">
      <p className="font-light text-body text-gray-700">
        Aucune traduction ne correspond à votre recherche.
      </p>
      <Button type="button" variant="ghost" onClick={onToutAfficher}>
        tout afficher
      </Button>
    </div>
  );
}
